import React from "react";
import { motion } from "framer-motion";

export default function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <section className="pt-32 sm:pt-40 pb-12 sm:pb-16 bg-offwhite border-b border-border-light" data-testid="page-header">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl"
        >
          {eyebrow && <span className="text-xs font-bold tracking-[0.2em] uppercase text-navy">{eyebrow}</span>}
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-navy tracking-tighter leading-tight">{title}</h1>
          {subtitle && <p className="mt-5 text-lg text-text-muted leading-relaxed">{subtitle}</p>}
        </motion.div>
      </div>
    </section>
  );
}
